import { isNavigationFailure, NavigationFailureType } from 'vue-router'
import { ElNotification } from 'element-plus'

import router from '@/router/index'
import { useUserStore } from '@/stores/user'
import { USER_INFO } from './constance'
import { Local } from './storage'

/**
 * 导航失败有错误消息的路由push
 * @param to — 导航位置，同 router.push
 */
export const routePush = async (to) => {
  try {
    const failure = await router.push(to)
    if (isNavigationFailure(failure, NavigationFailureType.aborted)) {
      ElNotification({
        message: '导航失败，导航守卫拦截！',
        type: 'error'
      })
    } else if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
      console.warn({
        message: '导航失败，已在导航目标位置！',
        type: 'warning'
      })
    }
  } catch (error) {
    ElNotification({
      message: '导航失败，路由无效！',
      type: 'error'
    })
    console.error(error)
  }
}

/**
 * 打开菜单
 * @param menu 菜单数据
 */
export const onClickMenu = (menu) => {
  if (typeof menu === 'string') {
    return routePush({ name: menu })
  }
  switch (menu.meta?.type) {
    case 'menu':
    case 'tab':
      routePush({ name: menu.name })
      break
    case 'link':
      window.open(menu.path, '_blank')
      break
    default:
      ElNotification({
        message: '导航失败，菜单类型无法识别！',
        type: 'error'
      })
      break
  }
}

/**
 * 动态添加路由
 */
export function addRouteAll (routes) {
  routes.forEach((r) => {
    return router.addRoute(r)
  })
}

/**
 * 组合菜单数据
*/
export function traversalMenus (routes, parentPath = '') {
  const result = []
  routes.forEach((r) => {
    let { path, name, meta = {}, children } = r
    // 是否需要生成对应展示菜单
    if (
      !meta.hidden
    ) {
      let child = []
      let childObj = {}
      if (children && children.length) {
        child = traversalMenus(children, path)
        childObj = child.length ? { children: child } : {}
      } else {
        childObj = {}
      }
      // 外部链接地址
      if (!meta.type || meta.type === 'menu') {
        path = parentPath ? `${parentPath}/${path}` : `${parentPath}${path}`
      }
      result.push({
        path,
        name,
        meta,
        ...childObj
      })
    }
  })
  return result
}

/**
 * 组合路由
*/
export function traversalRoutes (routes, parentPath = '', breadcrumbs = []) {
  let result = []
  routes.forEach((r) => {
    let { path, name, redirect, meta = {}, component, children } = r
    // 排除外部链接地址
    if (!meta.type || meta.type === 'menu') {
      path = parentPath ? `${parentPath}/${path}` : `${parentPath}${path}`
    }
    component = component ? { component } : {}
    result.push({
      path,
      name,
      redirect,
      meta: {
        ...meta,
        breadcrumbs: [...breadcrumbs, { path, title: meta.title }]
      },
      ...component
    })
    // 展开子路由
    let child = []
    if (children && children.length) {
      child = traversalRoutes(children, path, [...breadcrumbs, { path, title: meta.title }])
      result = result.concat(child)
    }
  })
  return result
}

/**
 * 跳转注册
 */
export function handleToRegister () {
  const redirectUrl = location.href
  location.href = `${process.env.VUE_APP_REGISTER}?redirectURL=${encodeURIComponent(redirectUrl)}`
}

/**
 * 跳转登录
 */
export function handleToLogin () {
  const redirectUrl = location.href
  location.href = `${process.env.VUE_APP_LOGIN}?redirectURL=${encodeURIComponent(redirectUrl)}`
}

/**
 * 跳转退出
 */
export function handleToLogout () {
  const redirectUrl = `${process.env.VUE_APP_LOGIN}?redirectURL=${encodeURIComponent(location.origin)}`
  const cloudUrl = `${process.env.VUE_APP_ClOUD_LOGOUT}?service=3px7XBpqtn3HqswIlWYMqad3VTSoGsJM&return_to=`
  const returnUrl = `${process.env.VUE_APP_LOGOUT}?redirectUrl=${redirectUrl}`
  // 移除用户信息
  Local.remove(USER_INFO)
  location.href = `${cloudUrl}${encodeURIComponent(returnUrl)}`
}

/**
* 授权路由需跳转登录页
*/
export function handleAuthLogin (route) {
  const user = useUserStore()
  user.deleteUserInfo()
  Local.remove(USER_INFO)
  if (route?.meta.auth) handleToLogin()
}
